import { trigger, animate, transition, style } from '@angular/animations';

export const blinkAnimation =
  trigger('blink', [
    transition(':increment', [
      animate(500, style({ opacity: 0, color: '#98ff65' })),
      animate(500, style({ opacity: 1, color: '#98ff65' })),
      animate(500, style({ opacity: 0, color: '#98ff65' })),
      animate(500, style({ opacity: 1, color: '#98ff65' })),
      animate(500, style({ opacity: 0, color: '#98ff65' })),
      animate(500, style({ opacity: 1, color: '#98ff65' })),
      animate(500, style({ opacity: 0, color: '#98ff65' })),
    ]),
    transition(':decrement', [
      animate(500, style({ opacity: 0, color: '#ff2e75' })),
      animate(500, style({ opacity: 1, color: '#ff2e75' })),
      animate(500, style({ opacity: 0, color: '#ff2e75' })),
      animate(500, style({ opacity: 1, color: '#ff2e75' })),
      animate(500, style({ opacity: 0, color: '#ff2e75' })),
      animate(500, style({ opacity: 1, color: '#ff2e75' })),
      animate(500, style({ opacity: 0, color: '#ff2e75' })),
    ]),
  ]);

export const blinkBorderAnimation =
  trigger('blink-border', [
    transition(':increment', [
      animate(500, style({ opacity: 0, 'border-color': '#98ff65', color: '#98ff65' })),
      animate(500, style({ opacity: 1, 'border-color': '#98ff65', color: '#98ff65' })),
      animate(500, style({ opacity: 0, 'border-color': '#98ff65', color: '#98ff65' })),
      animate(500, style({ opacity: 1, 'border-color': '#98ff65', color: '#98ff65' })),
      animate(500, style({ opacity: 0, 'border-color': '#98ff65', color: '#98ff65' })),
      animate(500, style({ opacity: 1, 'border-color': '#98ff65', color: '#98ff65' })),
      animate(500, style({ opacity: 0, 'border-color': '#98ff65', color: '#98ff65' })),
      // query('.online-odd', [ animate(3500, style({ color: '#98ff65' }))])
    ]),
    transition(':decrement', [
      animate(500, style({ opacity: 0, 'border-color': '#ff2e75', color: '#ff2e75' })),
      animate(500, style({ opacity: 1, 'border-color': '#ff2e75', color: '#ff2e75' })),
      animate(500, style({ opacity: 0, 'border-color': '#ff2e75', color: '#ff2e75' })),
      animate(500, style({ opacity: 1, 'border-color': '#ff2e75', color: '#ff2e75' })),
      animate(500, style({ opacity: 0, 'border-color': '#ff2e75', color: '#ff2e75' })),
      animate(500, style({ opacity: 1, 'border-color': '#ff2e75', color: '#ff2e75' })),
      animate(500, style({ opacity: 0, 'border-color': '#ff2e75', color: '#ff2e75' })),
      // query('.online-odd', [ animate(3500, style({ color: '#ff2e75' }))])
    ]),
  ]);

